// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
// import 'innersvg-polyfill'
import Vue from 'vue'

import './utils/plugins'

// Axios interceptors
import './axios/interceptors'

// Filters
import './utils/filters'

// Directives
import './utils/directives'

// global components
import './utils/global-components'

Vue.config.productionTip = false

// analytics
import analytics from './api/analytics'
Vue.prototype.$analytics = analytics

// Strings
import strings from './strings'
Vue.prototype.$strings = strings

// Feature toggle
import { toggle } from './api/toggle'
window.toggles = toggle
Vue.prototype.$toggle = toggle

// Profile
import { getCookie } from './utils/auth-utils'
window.profile = getCookie('profile')
Vue.prototype.$profile = getCookie('profile')

// Create vue instance
import App from './App'
import router from './router'
import store from './store'

import VueMask from 'v-mask'
import VueSlickCarousel from 'vue-slick-carousel'
import { VueReCaptcha } from 'vue-recaptcha-v3'

import 'vue-slick-carousel/dist/vue-slick-carousel.css'
// optional style for arrows & dots
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'
import '../static/stylesheets/helpers.css'
import '../static/stylesheets/monthly-themes.css'
import { applyMonthlyTheme } from './utils/monthly-theme-manager'

Vue.component('VueSlickCarousel', VueSlickCarousel)

Vue.use(VueMask)

// reCAPTCHA Global Configuration
Vue.use(VueReCaptcha, {
  siteKey: process.env.RECAPTCHA_SITE_KEY,
  loaderOptions: {
    autoHideBadge: false,
    useEnterprise: true,
    explicitRenderParameters: {
      badge: 'bottomright',
    },
  },
})

// Aplica tema mensal
applyMonthlyTheme()

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  components: { App },
  template: '<App/>',
})
